import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtistContractTemplates = (params, page = 1, pageSize = 2147483647, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-contract-templates/?page=' + page + '&page_size=' + pageSize, {
    params: params,
    cancelToken: cancelToken?.token
  })
}

export const getArtistContractTemplate = (id) => {
  return axios.get(URL_PREFIX + '/artist-contract-templates/' + id + '/')
}